
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import {extend} from './../../zviz2/zviz/functions';
import {addToBoundingBox} from './functions';
import config from './../../config';
import Vector2 from './../../zviz2/zviz/math/vector2';
import MapItem from './mapitem';

//import {LifeCycle} from './../zviz2/zviz/cycle';
import flowModel from './../../model/flow';


class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.maxValue = 0;

        this.nonGeographicCentroids = new Map();
        
    }

    getNonGeoData(value, dimension){
        let c = new Vector2(0, 0);
        let key = dimension + '.' + value;
        if(this.nonGeographicCentroids.has(key)){
            c = this.nonGeographicCentroids.get(key).copy();
        }else{
            c.y = this.getControllerByUid('svg').getHeight()-20;
            c.x = 30;
            let w = 180;
            let h = 65;
            for(let [k, v] of this.nonGeographicCentroids){
                c.x = v.x + w;
                c.y = v.y;
            }
            if(c.x + w > this.getControllerByUid('svg').getWidth()){
                c.y -= h;
                c.x = 30;
            }
            this.nonGeographicCentroids.set(key, c);
        }
        return {
            ids: [],
            centroid: c,
            notOnMap: true
        };
    }

    getLocation(value, dimension, full=false){
        let geoData = this.getControllerByUid('countries').getGeoData(value, dimension);
        if(geoData == null){
            geoData = this.getNonGeoData(value, dimension);
        }
        if(! full){
            return geoData.centroid;
        }
        return geoData;
    }

    getChildren(){

        let result = [];
        this.maxValue = 0;
        let dimension = this.models['flow'].dimensionRegion;

        let items = this.models['flow'].items;
        if(! items || ! items[dimension]){
            return [];
        }
        this.nonGeographicCentroids = new Map();

        for(let dim of Object.keys(items)){

            for(let item of items[dimension]){
                if(item.amount > this.maxValue){
                    this.maxValue = item.amount;
                }

                if(dim == dimension){
                    let geoData = this.getLocation(item.value, dimension, true)

                    result.push(extend({
                        uid: '_mi_' + dim + item.value,
                        properties: {
                            data: {
                                dim: dim,
                                name: item.value,
                                amount: item.amount,
                                coords: [geoData.centroid.x, geoData.centroid.y],
                                countries: geoData.ids,
                                notOnMap: geoData.notOnMap || false
                            }
                        }
                    }, MapItem));
                }
            }

        }

        // largest item should be place first so that smaller will not disappear behind it
        result.sort(function(a, b){
            if(a.properties.data.amount <= b.properties.data.amount){
                return 1;
            }
            return -1;
        });

        return result;

    }

} 


let Blueprint = extend({
    type: Controller,
    models: {
        'flow': null
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(ctrl.models['flow'], [ctrl, ctrl.update])),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'map.transformation') )
    ],
    uid: 'geodata',
    properties: {
        transform: {
            position: {y: config.display.mapOffset.top}
        }
    },
    children: [
       (ctrl) => ( ctrl.getChildren() )
    ]
}, Group);


export default Blueprint;
export {Controller, Blueprint};

